import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';

import './header.css';
import logo from '../../assets/logo.png';

const Header = ({pages, onContactClick}) => {
  const scrollTo = (ref) => ref.current.scrollIntoView({behavior: 'smooth', block: 'start'})
  const [activeIndex, setActiveIndex] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const nearestIndex = (currentPosition, sectionPositionArray, startIndex, endIndex) => {
      if (startIndex === endIndex) return startIndex;
      else if (startIndex === endIndex - 1) {
        if (
          Math.abs(sectionPositionArray[startIndex].ref.current.offsetTop - currentPosition) <
          Math.abs(sectionPositionArray[endIndex].ref.current.offsetTop - currentPosition)
        )
          return startIndex;
        else return endIndex;
      } else {
        var nextNearest = ~~((startIndex + endIndex) / 2);
        var a = Math.abs(sectionPositionArray[nextNearest].ref.current.offsetTop - currentPosition);
        var b = Math.abs(sectionPositionArray[nextNearest + 1].ref.current.offsetTop - currentPosition);
        if (a < b) {
          return nearestIndex(currentPosition, sectionPositionArray, startIndex, nextNearest);
        } else {
          return nearestIndex(currentPosition, sectionPositionArray, nextNearest, endIndex);
        }
      }
    };

    const handleScroll = (e) => {
      var index = nearestIndex(window.scrollY, pages, 0, pages.length - 1);
      setActiveIndex(index);
      setScrolled(window.scrollY > 50);
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <motion.header
      className={`navigation-header ${scrolled ? 'scrolled' : ''}`}
    >
      <div className="nav-container">
        <motion.img
          src={logo}
          alt='RockSoftware'
          className="logo"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        />
        <motion.ul
          className="menu"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
        {
          pages.map((item, index) => (
            <motion.li
              key={index}
              className={activeIndex === index ? "menu-item-active" : ""}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="menu-item" onClick={() => {scrollTo(item.ref)}}>
                {item.title}
              </span>
            </motion.li>
          ))
        }
        <motion.li
          className="btn-contact-container"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="btn-contact" onClick={onContactClick}>
            <span>Contact Us</span>
          </span>
        </motion.li>
        </motion.ul>
      </div>
    </motion.header>
  )
}

export default Header;